import { Close, DragIndicator } from "../../icons";
import { IconButton } from "../deprecated/IconButton";
export const draggablePopperSlots = {
    dragButton: IconButton,
    closeButton: IconButton,
    dragIcon: DragIndicator,
    closeIcon: Close,
};
//# sourceMappingURL=types.js.map